<template>
  <!-- 执业资格证管理 -->
  <div class="content main-container">
    <div class="wrapper">
      <div class="search-box btn3" :class="{ close: !searchMore }">
        <div class="input-item">
          <span class="label">姓名</span>
          <Input v-model="searchParams.userName" placeholder="请输入姓名" clearable />
        </div>
        <div class="input-item">
          <span class="label">机构/团队</span>
          <selectTree type="2" v-model="selectTreeId" @change="selectTreeChange"></selectTree>
        </div>
        <div class="input-item">
          <span class="label">人员状态</span>
          <RadioGroup v-model="searchParams.workingState" @on-change="searchAjax()">
            <Radio label="">全部</Radio>
            <Radio label="0">离职</Radio>
            <Radio label="1">在职</Radio>
          </RadioGroup>
        </div>
        <div class="input-item">
          <span class="label">手机号</span>
          <Input v-model="searchParams.mobile" placeholder="请输入手机号" clearable />
        </div>
        <div class="input-item">
          <span class="label">身份证号</span>
          <Input v-model="searchParams.idCard" placeholder="请输入身份证号" clearable />
        </div>
        <div class="input-item" v-if="tabModel == 1">
          <span class="label">执业证号</span>
          <Input v-model="searchParams.certificateNumber" placeholder="请输入执业证号" clearable />
        </div>
        <div class="btn-item">
          <Button type="primary" @click="searchAjax()">查询</Button>
          <Button
            type="primary"
            ghost
            @click="
              resetSearch();
              selectTreeId = '';
            "
            >重置</Button
          >
          <Button type="primary" ghost v-if="searchMore" @click="searchMore = false">收起<Icon type="ios-arrow-up" /></Button>
          <Button type="primary" ghost v-else @click="searchMore = true">展开<Icon type="ios-arrow-down" /></Button>
        </div>
      </div>
      <div class="tabBox">
        <Tabs v-model="tabModel" :animated="false" @on-click="toggleTab" class="tabs-box">
          <TabPane label="人员管理" name="1"></TabPane>
          <!-- <TabPane label="异动记录" name="2"></TabPane> -->
          <template #extra>
            <Button v-if="tabModel == 1 && $units.pointAction('org_12_3')" type="warning" @click="removalAll()">批量导入</Button>
            <Button v-if="tabModel == 1 && $units.pointAction('org_12_4')" type="warning" @click="exportExcel()" ghost>导出</Button>
          </template>
        </Tabs>
        <Tabs @on-click="toggleTabSecond" v-model="queryTab" v-if="tabModel == 1" class="second-tabs" :animated="false">
          <TabPane label="全部" name=""></TabPane>
          <TabPane label="已认证" name="1"></TabPane>
          <TabPane label="未认证" name="0"></TabPane>
        </Tabs>
      </div>
      <div class="table-box" v-if="tabModel == 1">
        <loading :isShow="$root.$children[0].isShowLoading" />
        <Table :columns="columns" :data="tableData">
          <!-- 手机号 -->
          <template slot-scope="{ row }" slot="mobile">
            <div style="display: flex; align-items: center; white-space: nowrap; justify-content: center">
              <span v-if="row.eyeShow">{{ row.mobile1 }}</span>
              <span v-else>{{ row.mobile }}</span>
              <div v-if="row.mobile">
                <i class="iconfont iconxianshi eye-icon eye" v-if="row.eyeShow" @click="openEye(row,'mobile1',2,'eyeShow')"></i>
                <i class="iconfont iconyincang eye-icon eye" v-else @click="openEye(row,'mobile1',2,'eyeShow')"></i>
              </div>
            </div>
          </template>
          <template slot-scope="{ row }" slot="idCard">
            <div style="display: flex; align-items: center; white-space: nowrap; justify-content: center">
              <span v-if="row.eyeShow1">{{ row.idCard1 }}</span>
              <span v-else>{{ row.idCard }}</span>
              <div v-if="row.idCard">
                <i class="iconfont iconxianshi eye-icon eye" v-if="row.eyeShow1" @click="openEye(row,'idCard1',1,'eyeShow1')"></i>
                <i class="iconfont iconyincang eye-icon eye" v-else @click="openEye(row,'idCard1',1,'eyeShow1')"></i>
              </div>
            </div>
          </template>
          <template slot-scope="{ row }" slot="action">
            <div class="detail" v-if="$units.pointAction('org_12_2')">
              <div v-if="row.qualificationFlag == 1" @click="removal(row)">注销</div>
              <div v-if="row.qualificationFlag == 0" :class="{ disabled: row.workingState == 0 && row.qualificationFlag == 0 }" @click="updateZynum(row.id)">
                上号
              </div>
            </div>
          </template>
        </Table>
        <div class="pageBox">
          <Page :total="total" :current="pageNo" :page-size="pageSize" show-total @on-change="pageChange" style="text-align: center" />
        </div>
      </div>
      <div class="table-box" v-else>
        <loading :isShow="$root.$children[0].isShowLoading" />
        <Table :columns="columns2" :data="tableData2">
          <template slot-scope="{ row }" slot="mobile">
            <div style="display: flex; align-items: center; white-space: nowrap; justify-content: center">
              <span v-if="row.eyeShow">{{ row.mobile1 }}</span>
              <span v-else>{{ row.mobile }}</span>
              <div v-if="row.mobile">
                <i class="iconfont iconxianshi eye-icon eye" v-if="row.eyeShow" @click="openEye(row,'mobile1',2,'eyeShow')"></i>
                <i class="iconfont iconyincang eye-icon eye" v-else @click="openEye(row,'mobile1',2,'eyeShow')"></i>
              </div>
            </div>
          </template>
          <template slot-scope="{ row }" slot="idCard">
            <div style="display: flex; align-items: center; white-space: nowrap; justify-content: center">
              <span v-if="row.eyeShow1">{{ row.idCard1 }}</span>
              <span v-else>{{ row.idCard }}</span>
              <div v-if="row.idCard">
                <i class="iconfont iconxianshi eye-icon eye" v-if="row.eyeShow1" @click="openEye(row,'idCard1',1,'eyeShow1')"></i>
                <i class="iconfont iconyincang eye-icon eye" v-else @click="openEye(row,'idCard1',1,'eyeShow1')"></i>
              </div>
            </div>
          </template>
        </Table>
        <div class="pageBox">
          <Page :total="total2" :current="pageNo2" :page-size="pageSize2" show-total @on-change="pageChange2" style="text-align: center" />
        </div>
      </div>
      <!-- 上号  -->
      <Modal class="logBox my-modal top" v-model="showlog" title="上号" @on-ok="confirmlog" width="500" :loading="$root.$children[0].modalLoading">
        <Form :model="logBoxForm" ref="logBoxFormRef" :label-width="100" :rules="logBoxFormRules" class="formGauge">
          <FormItem label="执业证号" prop="certificateNumber">
            <Input v-model="logBoxForm.certificateNumber" class="input-value" :maxlength="26" :show-word-limit="true" placeholder="请输入执业证号" clearable />
          </FormItem>
        </Form>
      </Modal>
      <import-tool ref="importTool" @success="searchAjax()"></import-tool>
    </div>
  </div>
</template>
<script>
import { pageTool, common } from "@/api/mixins";
import filters from '@/api/filter.js';
import selectTree from '@/components/system/selectTree3';
import topSearchForm from '@/components/commons/topSearchForm';
import importTool from '@/components/commons/importTool/index2';
import { updateCertificateNumber } from '@/api/httpList';
export default {
  mixins: [pageTool, common],
  components: {
    selectTree,
    topSearchForm,
    importTool
  },
  data: () => ({
    logId: '', // 上号id
    logBoxForm: {
      certificateNumber: '' // 执业证号
    },
    logOutId: '', // 注销id
    showlog: false, // 注销
    selectTreeId: '', // 选中的树节点的id
    tabModel: '1',
    queryTab: '',
    pageNo: 1,
    pageNo2: 1,
    pageSize: 10,
    pageSize2: 10,
    total: 0,
    total2: 0,
    searchParams: {
      userName: '', // 姓名
      groupId: '', // 所属团队id
      organizationId: '', //所属机构id
      workingState: '', // 人员状态
      mobile: '', // 手机号
      idCard: '', // 身份证号
      certificateNumber: '', // 执业资格号
      qualificationFlag: '' // 认证状态
    },
    tableData: [],
    tableData2: [],
    logBoxFormRules: {
      certificateNumber: [
        {
          required: true,
          message: '请输入执业证号',
          trigger: 'blur'
        },
        {
          message: '执业证号只能是字母或数字',
          validator(rule, value) {
            const reg = /^[0-9a-zA-Z]*$/i;
            return reg.test(value.trim());
          }
        }
      ]
    },
    columns: [
      {
        title: '工号',
        key: 'staffNo',
        align: 'center',
        minWidth: 120,
        fixed: 'left'
      },
      {
        title: '姓名',
        key: 'userName',
        align: 'center',
        minWidth: 120,
        fixed: 'left'
      },
      {
        title: '手机号',
        slot: 'mobile',
        align: 'center',
        minWidth: 180
      },
      {
        title: '所属机构',
        key: 'organizationName',
        align: 'center',
        minWidth: 180
      },

      {
        title: '所属团队',
        key: 'groupName',
        align: 'center',
        minWidth: 180
      },
      {
        title: '人员状态',
        key: 'workingState',
        align: 'center',
        width: 100,
        render(h, params) {
          const type = params.row.workingState;
          if (type === '0') {
            return <span>离职</span>;
          }
          if (type === '1') {
            return <span>在职</span>;
          }
        }
      },
      {
        title: '证件类型',
        width: '200',
        align: 'center',
        render(h, param) {
          if (param.row.idType) {
            let dic = JSON.parse(localStorage.dic)['USER_CARD_TYPE'];
            return <span>{dic[param.row.idType]}</span>;
          } else {
            return <span>-</span>;
          }
        }
      },
      {
        title: '证件号',
        slot: 'idCard',
        align: 'center',
        minWidth: 180
      },
      {
        title: '认证状态',
        key: 'qualificationFlag',
        align: 'center',
        width: 100,
        render(h, params) {
          const type = params.row.qualificationFlag;
          if (type === '0') {
            return <span>未认证</span>;
          }
          if (type === '1') {
            return <span>已认证</span>;
          }
          if (type === '2') {
            return <span>待审核</span>;
          }
        }
      },
      {
        title: '执业证号',
        key: 'certificateNumber',
        align: 'center',
        minWidth: 200,
        render(h, params) {
          return <span>{params.row.certificateNumber || '-'}</span>;
        }
      },
      {
        title: '执业证有效期',
        key: 'certificateNumber',
        align: 'center',
        minWidth: 200,
        render(h, params) {
          if (!params.row.certificateIssuanceDate && !params.row.certificateEndDate) {
            return <span>-</span>;
          } else {
            return (
              <span>
                {filters.filterTime(params.row.certificateIssuanceDate, 'YYYY-MM-DD') || '-'}至{filters.filterTime(params.row.certificateEndDate, 'YYYY-MM-DD')  || '-'}
              </span>
            );
          }
        }
      },
      {
        title: '操作',
        slot: 'action',
        align: 'center',
        width: '100',
        fixed: 'right'
      }
    ],
    columns2: [
      {
        title: '工号',
        key: 'staffNo',
        align: 'center',
        fixed: 'left',
        minWidth: 120
      },
      {
        title: '姓名',
        key: 'userName',
        align: 'center',
        minWidth: 120,
        fixed: 'left'
      },
      {
        title: '手机号',
        slot: 'mobile',
        align: 'center',
        width: 180
      },
      {
        title: '所属机构',
        key: 'organizationName',
        align: 'center',
        minWidth: 160
      },
      {
        title: '所属团队',
        key: 'groupName',
        align: 'center',
        minWidth: 160
      },
      {
        title: '人员状态',
        key: 'workingState',
        width: 100,
        align: 'center',
        render(h, params) {
          if (params) {
            const type = params.row.workingState;
            if (type === '0') {
              return <span>离职</span>;
            }
            if (type === '1') {
              return <span>在职</span>;
            }
          }
        }
      },
      {
        title: '证件类型',
        width: '200',
        align: 'center',
        render(h, param) {
          if (param.row.idType) {
            let dic = JSON.parse(localStorage.dic)['USER_CARD_TYPE'];
            return <span>{dic[param.row.idType]}</span>;
          } else {
            return <span>-</span>;
          }
        }
      },
      {
        title: '证件号',
        slot: 'idCard',
        align: 'center',
        minWidth: 180
      },
      {
        title: '异动类型',
        key: 'reason',
        align: 'center',
        minWidth: 120
      },
      {
        title: '新执业证号',
        key: 'newCertificateNumber',
        align: 'center',
        minWidth: 150,
        render(h, params) {
          return <span>{params.row.newCertificateNumber || '-'}</span>;
        }
      },
      // {
      //   title: '原因',
      //   key: 'reason',
      //   align: 'center',
      //   minWidth: 200,
      // },
      {
        title: '变更时间',
        key: 'changeTime',
        align: 'center',
        minWidth: 160,
        render(h, params) {
          const time = filters.filterTime(params.row.createTime, 'YYYY/MM/DD HH:mm');
          return <span>{time}</span>;
        }
      }
    ]
  }),
  created() {
    if (!this.$units.pointAction('org_12_2')) {
      this.columns.splice(this.columns.length - 1, 1);
    }
    this.getList();
  },
  methods: {
    // 解密
    openEye(row,name,i,eyeShow) {
      let val
      if(this.tabModel == 1){
         val= {
          query: row.id,
          operationFunction: 31,
          operationType: i,
        }
      }else{
        val= {
          query: row.userId,
          operationFunction: 31,
          operationType: i,
        }
      }
      if (!row[eyeShow]) {
        this.descrypt(val, row, name).then(() => {
          this.$set(row, eyeShow, true);
        })
      } else {
        this.$set(row, eyeShow, false);
      }
    },
    // 导出
    exportExcel() {
      this.$root.$children[0].isShowLoading = true;
      let data = JSON.parse(JSON.stringify(this.searchParams));
      delete data.pageNo;
      delete data.pageSize;
      this.$http({
        url: '/buz/userBase/exportCertificateNum',
        type: 'POST',
        responseType: 'blob',
        data,
        apiPermissionCode: 'org_12_4'
      })
        .then(res => {
          this.$root.$children[0].isShowLoading = false;
          this.$units.daochu(res);
        })
        .catch(e => {
          this.$root.$children[0].isShowLoading = false;
        });
    },
    /**
     * 批量上编、注销 type 1上编 2注销
     */
    removalAll() {
      const dic = JSON.parse(localStorage.dic)['USER_CERTIFICATE_NUMBER_EXPORT'];
      const key = Object.getOwnPropertyNames(dic)[0];
      this.$refs.importTool.open({
        params: {},
        uploadParams: {},
        template: key,
        templateName: dic[key],
        uploadUrl: '/buz/userBase/batch/cancelOrAddCertificateNumber',
        errorUrl: '/buz/userBase/exportErrorCertificateNum',
        apiPermissionCode: 'org_12_3'
      });
    },
    toggleTab() {
      if (this.tabModel == 1) {
        this.$root.$children[0].isShowLoading = true;
        this.pageNo = 1;
        this.getList();
      } else if (this.tabModel == 2) {
        this.$root.$children[0].isShowLoading = true;
        this.pageNo2 = 1;
        this.getList2();
      }
    },
    toggleTabSecond() {
      this.pageNo = 1;
      this.searchParams.qualificationFlag = this.queryTab ? this.queryTab : '';
      this.getList();
    },
    selectTreeChange(item) {
      this.searchParams.organizationId = '';
      this.searchParams.groupId = '';
      if (item.nodeType == 1) {
        this.searchParams.organizationId = item.id;
      } else if (item.nodeType == 2) {
        this.searchParams.groupId = item.id;
      }
    },
    getList() {
      this.searchParams.pageNo = this.pageNo;
      this.searchParams.pageSize = this.pageSize;
      this.$units.delNull(this.searchParams);
      this.$http({
        url: '/buz/userBase/manage/list',
        type: 'POST',
        data: this.searchParams,
        apiPermissionCode: 'org_12_0'
      })
        .then(res => {
          this.$root.$children[0].isShowLoading = false;
          this.tableData = res.data;
          this.total = res.total;
        })
        .catch(e => {
          this.$root.$children[0].isShowLoading = false;
        });
    },
    searchAjax() {
      if (this.tabModel == 1) {
        this.$root.$children[0].isShowLoading = true;
        this.pageNo = 1;
        this.getList();
      } else {
        this.$root.$children[0].isShowLoading = true;
        this.pageNo2 = 1;
        this.getList2();
      }
    },
    getList2() {
      let params = {
        userName: this.searchParams.userName, // 姓名
        groupId: this.searchParams.groupId, // 所属团队id
        organizationId: this.searchParams.organizationId, //所属机构id
        workingState: this.searchParams.workingState, // 人员状态
        mobile: this.searchParams.mobile, // 手机号
        idCard: this.searchParams.idCard, // 身份证号
        certificateNumber: this.searchParams.certificateNumber, // 执业资格号
        pageNo: this.pageNo2,
        pageSize: this.pageSize2
      };
      this.$units.delNull(params);
      this.$http({
        url: '/buz/certificateChangeRecord/read/list',
        type: 'POST',
        data: params
      })
        .then(res => {
          this.$root.$children[0].isShowLoading = false;
          this.tableData2 = res.data;
          this.total2 = res.total;
        })
        .catch(e => {
          this.$root.$children[0].isShowLoading = false;
        });
    },
    pageChange(pageNo) {
      this.$root.$children[0].isShowLoading = true;
      this.pageNo = pageNo;
      this.getList();
    },
    pageChange2(pageNo) {
      this.$root.$children[0].isShowLoading = true;
      this.pageNo2 = pageNo;
      this.getList2();
    },
    // 上号
    updateZynum(id) {
      this.logBoxForm.certificateNumber = '';
      this.showlog = true;
      this.logId = id;
    },
    confirmlog() {
      this.logBoxForm.userId = this.logId;
      this.$units.notCloseModal(this);
      this.$refs['logBoxFormRef'].validate(valid => {
        if (valid) {
          this.$http({
            url: '/buz/userBase/updateCertificateNumber',
            type: 'POST',
            data: this.logBoxForm,
            apiPermissionCode: 'org_12_2'
          }).then(res => {
            this.$Message.success('操作成功');
            this.showlog = false;
            this.$root.$children[0].isShowLoading = true;
            this.getList();
          });
        }
      });
    },
    // 注销
    removal(row) {
      this.$Modal.confirm({
        title: '请确认注销当前执业证号',
        content: '注意：注销后该员工执业证号为暂无',
        onOk: () => {
          this.$http({
            url: '/buz/userBase/cancelCertificateNumber',
            type: 'GET',
            data: {
              id: row.id
            },
            apiPermissionCode: 'org_12_2'
          }).then(res => {
            this.$Message.success('操作成功');
            this.$root.$children[0].isShowLoading = true;
            this.getList();
          });
        },
        onCancel: () => {}
      });
    }
  }
};
</script>
<style lang='scss' scoped>
/deep/.ivu-btn-ghost.ivu-btn-warning {
  background-color: transparent;
}
/deep/.search-box {
  margin-bottom: 15px;
}
.logBox {
  .log-box-form {
    display: flex;
    align-items: center;
    .label {
      width: 90px;
      margin-left: 10px;
      position: relative;
      &::before {
        content: '*';
        display: block;
        position: absolute;
        color: red;
        left: -8px;
        top: 0;
      }
    }
  }
  /deep/ .ivu-input {
    font-size: 13px;
  }
}
.content {
  .titleBox {
    background: #fff;
    border-bottom: 10px solid #f5f7f9;
    padding: 17px 26px;
    position: relative;

    .right {
      position: absolute;
      font-size: 14px;
      color: #727c8e;
      right: 25px;
      top: 50%;
      transform: translateY(-50%);

      &:hover {
        cursor: pointer;
      }

      span {
        margin-right: 6px;
      }
    }

    h1 {
      font-size: 24px;
      color: #3c464f;
      position: relative;
      padding-left: 10px;
      font-weight: bold;

      &:before {
        content: '';
        left: 0;
        top: 50%;
        margin-top: -10px;
        width: 4px;
        height: 20px;
        background: #236dff;
        opacity: 1;
        border-radius: 3px;
        position: absolute;
      }
    }

    p {
      font-size: 14px;
      color: #a8adb7;
      margin-top: 10px;
    }
  }
  .tabBox {
    margin-top: -10px;
    .tabs-box {
      /deep/ {
        .ivu-tabs-bar {
          border-bottom: 1px solid #ececec;
        }
        .ivu-tabs-ink-bar {
          display: none;
        }
        .ivu-tabs-tab {
          padding: 9px 0 10px;
          margin-right: 44px;
          font-size: 14px;
          color: #515c6f;
        }
        .ivu-tabs-tab-active {
          position: relative;
          color: #236dff;
          &::before {
            content: '';
            position: absolute;
            left: 0;
            bottom: 1px;
            height: 2px;
            width: 100%;
            background-color: #236dff;
          }
        }
      }
    }
  }
}
</style>
